import { cn } from '../lib/cn';

/** Shared surface/item styles for dropdown, context and select menus. */
export const menuSurface =
  'z-50 min-w-48 animate-scale-in rounded-lg bg-bg-2 p-1 text-sm text-text-1 shadow-popover outline-none';

export const menuItem = cn(
  'relative flex h-7 cursor-default items-center gap-2 rounded-md px-2 outline-none select-none',
  'data-[disabled]:pointer-events-none data-[disabled]:opacity-45',
  'data-[highlighted]:bg-bg-4 data-[state=open]:bg-bg-4',
  '[&_svg]:size-4 [&_svg]:shrink-0 [&_svg]:text-text-3',
);
